import { ASSIGN_PETITIONS_FAILED, ASSIGN_PETITIONS_SUCCESS } from '../ManagePetitions/actionTypes';
import {
  PRINT_PETITIONS_FAILED,
  PRINT_PETITIONS_SUCCESS,
} from '../ManagePetitions/PetitionsTable/actionTypes';
import { FORGOT_PASSOWRD_SUCCESS } from '../Auth/ForgotPassword/actionTypes';
import { SIGN_IN_FAILURE } from '../Auth/SignIn/actionTypes';
import { GENERATE_PETITION_FAILED } from '../GeneratePetitions/actionTypes';
import {
  CREATE_INITIATIVES_FAILED,
  CREATE_INITIATIVES_SUCCESS,
} from '../Initiative/Create/actionTypes';
import { EDIT_INITIATIVE_FAILED, EDIT_INITIATIVE_SUCCESS } from '../Initiative/Edit/actionTypes';
import {
  DELETE_INITIATIVE_SUCCESS,
  TRIGGER_PETITION_IMPORT_SCAN_SUCCESS,
  TRIGGER_PETITION_IMPORT_SCAN_FAILED,
} from '../Initiative/Initiatives/actionTypes';
import {
  UPDATE_ORGANIZATION_FAILED,
  UPDATE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_SUCCESS,
} from '../Organizations/List/actionTypes';
import { CREATE_ORGANIZATION_SUCCESS } from '../Organizations/Create/actionTypes';
import {
  GENERATE_API_TOKEN_FAILED,
  GENERATE_QC_TOKEN_FAILED,
} from '../Organizations/Edit/actionTypes';
import {
  MARK_AS_PHYSICALLY_CHECKED_IN_SUCCESS,
  POST_FIELD_REPORT_FAILURE,
  ASSIGN_PETITION_SUCCESS,
  INVALIDATE_PETITION_SUCCESS,
} from '../PetitionFieldReport/actionTypes';
import {
  SET_SETTINGS_FAILED,
  SET_SETTINGS_SUCCESS,
  UPDATE_SIGNATURE_ALERT_SUCCESS,
} from '../Settings/actionTypes';
import {
  DELETE_USERS_FAILED,
  DELETE_USERS_SUCCESS,
  RESEND_INVITE_SUCCESS,
  ADD_USER_WITH_CSV_SUCCESS,
  ADD_USER_WITH_CSV_FAILED,
} from '../Users/List/actionTypes';
import {
  DELETE_SMS_CAMPAIGN_SUCCESS as USER_DELETE_SMS_CAMPAIGN_SUCCESS,
  DELETE_SMS_CAMPAIGN_FAILURE as USER_DELETE_SMS_CAMPAIGN_FAILURE,
  PUT_SMS_CAMPAIGN_SUCCESS as USER_PUT_SMS_CAMPAIGN_SUCCESS,
  PUT_SMS_CAMPAIGN_FAILURE as USER_PUT_SMS_CAMPAIGN_FAILURE,
  POST_SEND_SMS_FAILURE as USER_POST_SEND_SMS_FAILURE,
  POST_SEND_SMS_SUCCESS as USER_POST_SEND_SMS_SUCCESS,
  POST_SMS_CAMPAIGN_SUCCESS as USER_POST_SMS_CAMPAIGN_SUCCESS,
} from '../Users/SmsCampaigns/actionTypes';
import { SET_ERROR, SET_SUCCESS, SET_INFO, CLEAR } from './actionTypes';
import { SEND_INVITE_SUCCESS, SEND_INVITE_FAILED } from '../Users/InviteByEmail/actionTypes';
import {
  CREATE_INVITE_LINK_FAILED,
  CREATE_INVITE_LINK_SUCCESS,
} from '../Users/CreateInviteLink/actionTypes';
import { UPDATE_USER_FAILED, UPDATE_USER_SUCCESS } from '../Users/Edit/actionTypes';
import {
  ADD_USER_WITH_FORM_FAILED,
  ADD_USER_WITH_FORM_SUCCESS,
} from '../Users/AddWithForm/actionTypes';
import { SIGN_UP_FAILURE, SIGN_UP_SUCCESS } from '../Auth/SignUp/actionTypes';
import { EDIT_LANDING_SUCCESS } from '../LandingPage/EditLandingPage/actionTypes';
import {
  UPDATE_JURISDICTION_FAILED,
  UPDATE_JURISDICTION_SUCCESS,
} from '../Jurisdictions/Edit/actionTypes';
import { DELETE_LANDING_PAGE_SUCCESS } from '../LandingPage/LandingPages/actionTypes';
import { DELETE_REGISTRATION_FORMS_SUCCESS } from '../RegistrationForm/RegistrationForms/actionTypes';
import { CREATE_REGISTRATION_FORM_SUCCESS } from '../RegistrationForm/CreateRegistrationForm/actionTypes';
import { NEW_PASSOWRD_FAILURE, NEW_PASSOWRD_SUCCESS } from '../Auth/NewPassword/actionTypes';
import {
  UPDATE_SETTINGS_FAILED,
  UPDATE_SETTINGS_PASSWORD_FAILED,
  UPDATE_SETTINGS_PASSWORD_SUCCESS,
  UPDATE_SETTINGS_SUCCESS,
} from '../SettingsPage/Redux/types';
import { DELETE_WALK_ROUTE_SUCCESS } from '../WalkRoute/List/actionTypes';
import {
  POST_GENERATE_ROUTE_SUCCESS,
  POST_GENERATE_ROUTE_FAILURE,
} from '../ManageProspects/actionTypes';
import {
  DELETE_RECRUITS_PAGE_FAILURE,
  DELETE_RECRUITS_PAGE_SUCCESS,
  IMPORT_CSV_RECRUITS_SUCCESS,
  POST_SMS_CAMPAIGN_SUCCESS,
  POST_SEND_SMS_SUCCESS,
  POST_SEND_SMS_FAILURE,
  POST_SMS_CAMPAIGN_FAILURE,
  IMPORT_CSV_RECRUITS_FAILURE,
  GENERATE_CSV_RECRUITS_FAILURE,
  POST_ASSOCIATE_WITH_SMS_CAMPAIGN_FAILURE,
} from '../Recruits/RecruitsPage/actionTypes';
import {
  DELETE_SMS_CAMPAIGN_SUCCESS,
  DELETE_SMS_CAMPAIGN_FAILURE,
  PUT_SMS_CAMPAIGN_SUCCESS,
  PUT_SMS_CAMPAIGN_FAILURE,
} from '../Recruits/RecruitsPage/SmsCampaigns/actionTypes';
import {
  POST_TEST_EMAIL_SUCCESS,
  POST_TEST_EMAIL_FAILURE,
} from '../CustomMethods/Shared/Form/actionTypes';

import { teamReducers } from '../Teams/reducer';
import { donateFormsListReducers } from '../DonateForms/List/reducer';
import { donateFormCreateReducers } from '../DonateForms/Create/reducer';
import { donateFormEditReducers } from '../DonateForms/Edit/reducer';
import { labelCreateReducer } from '../Labels/Create/reducer';
import { labelEditReducer } from '../Labels/Edit/reducer';
import { labelsListReducers } from '../Labels/List/reducer';

import { categoriesListReducers } from '../CustomMethods/List/reducer';

import { userLabelsListReducers } from '../Labels/UserLabelsList/reducer';
import { POST_MESSAGE_TO_CHAT_FAILURE } from '../Recruits/RecruitsPage/ChatComponent/actionTypes';
import { POST_MESSAGE_TO_CHAT_FAILURE as USER_POST_MESSAGE_TO_CHAT_FAILURE } from '../Users/ChatComponent/actionTypes';

import { SCAN_AND_UPLOAD_PETITIONS_FAILED } from '../BatchScanAndUpload/actionTypes';
import {
  FETCH_FILES_FROM_BUCKET_FAILED,
  POST_CREATE_FOLDER_FAILED,
  POST_CREATE_FOLDER_SUCCESS,
  DELETE_FILES_FAILED,
  DELETE_FILES_SUCCESS,
  POST_EXPORT_FILES_FAILED,
} from '../UploadAndScan/actionTypes';
import { POST_GENERATE_PETITIONS_CSV_FAILED } from '../ManagePetitions/GenerateCSVModal/actionTypes';

const initialState = {
  info: '',
  success: '',
  error: '',
  autoCloseDuration: undefined,
};

const notificationsReducer = (state = initialState, { type, error, success, payload }) => {
  switch (type) {
    case SET_ERROR:
    case ASSIGN_PETITIONS_FAILED:
    case GENERATE_PETITION_FAILED:
    case POST_FIELD_REPORT_FAILURE:
    case SET_SETTINGS_FAILED:
    case PRINT_PETITIONS_FAILED:
    case CREATE_INITIATIVES_FAILED:
    case EDIT_INITIATIVE_FAILED:
    case SIGN_IN_FAILURE:
    case UPDATE_ORGANIZATION_FAILED:
    case CREATE_INVITE_LINK_FAILED:
    case SEND_INVITE_FAILED:
    case UPDATE_USER_FAILED:
    case ADD_USER_WITH_FORM_FAILED:
    case ADD_USER_WITH_CSV_FAILED:
    case SIGN_UP_FAILURE:
    case UPDATE_JURISDICTION_FAILED:
    case NEW_PASSOWRD_FAILURE:
    case UPDATE_SETTINGS_FAILED:
    case UPDATE_SETTINGS_PASSWORD_FAILED:
    case DELETE_USERS_FAILED:
    case POST_GENERATE_ROUTE_FAILURE:
    case DELETE_RECRUITS_PAGE_FAILURE:
    case IMPORT_CSV_RECRUITS_FAILURE:
    case GENERATE_CSV_RECRUITS_FAILURE:
    case POST_SMS_CAMPAIGN_FAILURE:
    case POST_SEND_SMS_FAILURE:
    case DELETE_SMS_CAMPAIGN_FAILURE:
    case PUT_SMS_CAMPAIGN_FAILURE:
    case POST_ASSOCIATE_WITH_SMS_CAMPAIGN_FAILURE:
    case POST_TEST_EMAIL_FAILURE:
    case USER_DELETE_SMS_CAMPAIGN_FAILURE:
    case USER_PUT_SMS_CAMPAIGN_FAILURE:
    case USER_POST_SEND_SMS_FAILURE:
    case POST_MESSAGE_TO_CHAT_FAILURE:
    case USER_POST_MESSAGE_TO_CHAT_FAILURE:
    case GENERATE_API_TOKEN_FAILED:
    case GENERATE_QC_TOKEN_FAILED:
    case SCAN_AND_UPLOAD_PETITIONS_FAILED:
    case TRIGGER_PETITION_IMPORT_SCAN_FAILED:
    case FETCH_FILES_FROM_BUCKET_FAILED:
    case POST_CREATE_FOLDER_FAILED:
    case DELETE_FILES_FAILED:
    case POST_EXPORT_FILES_FAILED:
    case POST_GENERATE_PETITIONS_CSV_FAILED:
      return {
        ...state,
        error,
      };
    case SET_SUCCESS:
    case ASSIGN_PETITIONS_SUCCESS:
    case SET_SETTINGS_SUCCESS:
    case UPDATE_SIGNATURE_ALERT_SUCCESS:
    case PRINT_PETITIONS_SUCCESS:
    case CREATE_INITIATIVES_SUCCESS:
    case EDIT_INITIATIVE_SUCCESS:
    case FORGOT_PASSOWRD_SUCCESS:
    case MARK_AS_PHYSICALLY_CHECKED_IN_SUCCESS:
    case UPDATE_ORGANIZATION_SUCCESS:
    case DELETE_INITIATIVE_SUCCESS:
    case DELETE_USERS_SUCCESS:
    case CREATE_ORGANIZATION_SUCCESS:
    case DELETE_ORGANIZATION_SUCCESS:
    case SEND_INVITE_SUCCESS:
    case CREATE_INVITE_LINK_SUCCESS:
    case UPDATE_USER_SUCCESS:
    case ADD_USER_WITH_FORM_SUCCESS:
    case SIGN_UP_SUCCESS:
    case EDIT_LANDING_SUCCESS:
    case UPDATE_JURISDICTION_SUCCESS:
    case DELETE_LANDING_PAGE_SUCCESS:
    case DELETE_REGISTRATION_FORMS_SUCCESS:
    case CREATE_REGISTRATION_FORM_SUCCESS:
    case NEW_PASSOWRD_SUCCESS:
    case RESEND_INVITE_SUCCESS:
    case ASSIGN_PETITION_SUCCESS:
    case UPDATE_SETTINGS_PASSWORD_SUCCESS:
    case UPDATE_SETTINGS_SUCCESS:
    case INVALIDATE_PETITION_SUCCESS:
    case DELETE_WALK_ROUTE_SUCCESS:
    case POST_GENERATE_ROUTE_SUCCESS:
    case DELETE_RECRUITS_PAGE_SUCCESS:
    case IMPORT_CSV_RECRUITS_SUCCESS:
    case POST_SMS_CAMPAIGN_SUCCESS:
    case USER_POST_SMS_CAMPAIGN_SUCCESS:
    case POST_SEND_SMS_SUCCESS:
    case USER_POST_SEND_SMS_SUCCESS:
    case DELETE_SMS_CAMPAIGN_SUCCESS:
    case PUT_SMS_CAMPAIGN_SUCCESS:
    case POST_TEST_EMAIL_SUCCESS:
    case USER_DELETE_SMS_CAMPAIGN_SUCCESS:
    case USER_PUT_SMS_CAMPAIGN_SUCCESS:
    case TRIGGER_PETITION_IMPORT_SCAN_SUCCESS:
    case POST_CREATE_FOLDER_SUCCESS:
    case DELETE_FILES_SUCCESS:
      return {
        ...state,
        success,
      };
    // Longer success message cases
    case ADD_USER_WITH_CSV_SUCCESS:
      return {
        ...state,
        success,
        autoCloseDuration: 15000,
      };
    case SET_INFO:
    case teamReducers.createTeamSuccess:
    case teamReducers.updateTeamSuccess:
    case teamReducers.deleteTeamSuccess:
    case donateFormsListReducers.deleteDonateFormSuccess:
    case donateFormCreateReducers.createDonateFormSuccess:
    case donateFormEditReducers.updateDonateFormSuccess:
    case labelCreateReducer.createLabelSuccess:
    case labelEditReducer.editLabelSuccess:
    case labelsListReducers.deleteLabelSuccess:
    case categoriesListReducers.deleteItemRSuccess:
    case userLabelsListReducers.deleteLabelSuccess:
      return {
        ...state,
        success: payload.success,
      };
    case teamReducers.createTeamFailure:
    case categoriesListReducers.deleteItemRFailure:
      return {
        ...state,
        error: payload.error,
      };
    case CLEAR:
      return {
        ...state,
        error: '',
        success: '',
        info: '',
        autoCloseDuration: undefined,
      };
    default:
      return state;
  }
};

export default notificationsReducer;
